import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";

export function MaximumShippingPriceField({
  value,
  setValue,
}: {
  value: number | undefined;
  setValue: (value: number | undefined) => void;
}) {
  return (
    <RedoTextInput
      inputTypeHint="number"
      label="Maximum shipping price to cover (optional)"
      placeholder="Leave empty to cover all shipping costs"
      setValue={(value) => {
        setValue(value ? Number(value) : undefined);
      }}
      value={value?.toString() || ""}
    />
  );
}
